// @flow
import without from 'lodash.without';

import type {IStorage} from './typedef';

export class StoredSettingsManager {
    storage: IStorage;
    key: string;
    limit: number;

    constructor(storage: IStorage, key: string, limit: number) {
        this.storage = storage;
        this.key = key;
        this.limit = limit;
    }

    get(id: string) {
        const currentStore = this.storage.get(this.key);

        if (!currentStore) {
            return null;
        }

        const settings = currentStore.find(item => item.id === id);

        return settings && settings.value;
    }

    set(id: string, value: Object) {
        let settings = this.storage.get(this.key);

        if (Array.isArray(settings)) {
            const current = settings.find(setting => setting.id === id);

            if (current) {
                settings = without(settings, current);
                settings.unshift({...current, value});
            } else {
                settings.unshift({id, value});
            }
        } else {
            settings = [{id, value}];
        }

        this.storage.set(this.key, settings.slice(0, this.limit));
    }
}


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
